import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router";

import Button from "../../base-components/button";
import locale from "../../utilities/locale";
import classes from "./index.module.css";
import config from "../../config";

const Loading = () => {
  const isLogIn = useSelector((state) => state.app.isLogIn);
  const userOnDashboard = useSelector((state) => state.app.userOnDashboard);
  const currentScreen = useSelector((state) => state.app.currenrScreen);
  const routeName = currentScreen;
  if (isLogIn) {
    // if (userOnDashboard) {
    //   return <Redirect to={config.routes.showHoldings} />;
    // }
    return <Redirect to={routeName} />;
  } else {
    return <Redirect to={config.routes.login} />;
  }

  return (
    <div className={classes.Container}>
      <div className={classes.top}></div>
      <div className={classes.middle}>
        <h2 className={classes.Heading}>{"we are loading app"}</h2>
        <p className={classes.SubHeading}>{"Please wait a second..."}</p>
      </div>
      <div className={classes.bottom}></div>
    </div>
  );
};

export default Loading;
